var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link && _vm.id !== 15803)?_c('li',{class:_vm.ext},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }